import { useEffect, useState } from 'react';
import apiClient from '../../api/client';

interface ServiceVersion {
  name: string;
  version: string;
  commit: string;
}

const shortHash = (hash: string) => (hash && hash !== 'unknown' ? hash.substring(0, 7) : '');

const formatVersion = (label: string, info?: ServiceVersion | null) => {
  if (!info) return `${label} N/A`;
  const hash = shortHash(info.commit);
  return `${label} ${info.version}${hash ? ` (${hash})` : ''}`;
};

const uiCommit = shortHash(__GIT_COMMIT__);

export default function VersionFooter() {
  const [apiVersion, setApiVersion] = useState<ServiceVersion | null>(null);

  useEffect(() => {
    apiClient
      .get<ServiceVersion>('/version')
      .then(({ data }) => setApiVersion(data))
      .catch(() => {});
  }, []);

  return (
    <footer className="flex justify-end items-center px-4 py-1 text-[10px] text-gray-400 dark:text-gray-600 select-none">
      <span>
        UI {__APP_VERSION__}
        {uiCommit && ` (${uiCommit})`}
        {' | '}
        {formatVersion('OMS API', apiVersion)}
      </span>
    </footer>
  );
}
